import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useNavModel from "../model/navModel";
import useGlobalModel from "../model/globalModel";
import { forFind } from "../utils/utils";
import menuData from "../data/menuData.json";
import { Layout, Spin } from "antd";
import ScmMenu from "./menu";
import ScmHeader from "./header";
import ScmNav from "./nav";
import ScmRoute from "./route";

const { Sider, Content } = Layout;

const Index = () => {

    const history = useHistory();
    const { user, cm, loadingInfo: { loadingVisible, txt }, setLoadingInfo } = useGlobalModel();
    const { addNav } = useNavModel(() => []);

    //监听在地址栏输入url。
    useEffect(() => {
        history.listen((location, action) => {
            //每次切换页面 关闭全局loading
            setLoadingInfo({ loadingVisible: false, txt: "" });

            if (action === "POP" && location.pathname !== "/login" && user.token) {
                let findNav = forFind(menuData, location.pathname, "path", true);
                // console.log(location, action, "监听路有变化", findNav)
                addNav(findNav ? findNav.id : "404");
            }
        });

    }, []);

    return (
        <Spin tip={txt} spinning={loadingVisible}>
            <Layout style={{ height: "100vh" }}>
                <ScmHeader />
                <Layout>
                    <Sider className="layout-sider" trigger={null} collapsible collapsed={cm.collapsed} width={226} collapsedWidth={80}>
                        {/* <div className="layout-sider-shop">{user.shopName}</div> */}
                        <ScmMenu />
                    </Sider>
                    <Layout className="layout-section">
                        <ScmNav />
                        <Content>
                            <div className="layout-section-content">
                                <ScmRoute />
                            </div>
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        </Spin>
    )
}

export default Index;